import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';

import { MenuModule } from 'primeng/menu';

import { FormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  AccessPermissionsModule,
  BreadcrumbComponent,
  CloseMenuOnScrollDirective,
  CssStylerDirective,
  FilelinkModule,
  FormFieldComponent,
  FormFieldLabelDirective,
  GetEntryFieldWrapperClassPipe,
  GetIconCssClassPipe,
  GetViewConfigCssRulesPipe,
  InfiniteScrollDirective,
  OsosSelectModule,
  PrimeTextFormFieldControlDirective,
  PrimeWrapperFormFieldControlDirective,
  PropertyTranslatorPipe,
  SafePipe,
  TimeFromNowPipe,
  ValueBasedTooltipComponent,
} from '@osos/shared/utility';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { Drawer } from 'primeng/drawer';
import { InputTextModule } from 'primeng/inputtext';
import { OverlayModule } from 'primeng/overlay';
import { PopoverModule } from 'primeng/popover';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RippleModule } from 'primeng/ripple';
import { SelectModule } from 'primeng/select';
import { SkeletonModule } from 'primeng/skeleton';
import { SplitButtonStyle } from 'primeng/splitbutton';
import { ToastModule } from 'primeng/toast';
import { Tooltip } from 'primeng/tooltip';

import {
  HelpAndDocumentationButtonComponent,
  HelpButtonPositionerDirective,
} from '@osos/shared/help-and-documentation';
import {
  DelegationBadgeComponent,
  ExitDelegationButtonComponent,
  TieredSplitButtonComponent,
  UserDelegationsComponent,
} from '@osos/shared/ui';
import { ConfigComponent } from './components/config/config.component';
import { CounterWidgetItemComponent } from './components/counter-widget-item/counter-widget-item.component';
import { MiniCardViewComponent } from './components/counter-widget-item/mini-card-view/mini-card-view.component';
import { NotificationCounterMenuComponent } from './components/counter-widget-item/notification-counter-menu/notification-counter-menu.component';
import { CounterWidgetListComponent } from './components/counter-widget-list/counter-widget-list.component';
import { InlineMenuComponent } from './components/inline-menu/inline-menu.component';
import { MainComponent } from './components/main/main.component';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { MenuComponent } from './components/menu/menu.component';
import { MySpacesListComponent } from './components/my-spaces-list/my-spaces-list.component';
import { OsosAiComponent } from './components/osos-ai/osos-ai.component';
import { TopbarComponent } from './components/topbar/topbar.component';

import { NotificationMenuComponent } from './notification-menu/notification-menu.component';
import { SearchMenuItemLinkPipe } from './search-menu/search-menu-item-link.pipe';
import { SearchMenuItemsPipe } from './search-menu/search-menu-items.pipe';
import { SearchMenuComponent } from './search-menu/search-menu.component';
import { MenuAsideService } from './services/menu-aside.service';
import { MenuConfigService } from './services/menu-config.service';
import { MenuService } from './services/menu.service';
import { NavService } from './services/nav.service';
import { PortalMenuService } from './services/portal-menu.service';

@NgModule({
  declarations: [
    TopbarComponent,
    InlineMenuComponent,
    MenuComponent,
    MenuItemComponent,
    MainComponent,
    SearchMenuComponent,
    SearchMenuItemsPipe,
    SearchMenuItemLinkPipe,
    NotificationMenuComponent,
    NotificationCounterMenuComponent,
    MiniCardViewComponent,
    CounterWidgetListComponent,
    CounterWidgetItemComponent,
    OsosAiComponent,
    MySpacesListComponent,

    ConfigComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MenuModule,
    TranslateModule,
    AccessPermissionsModule,
    PropertyTranslatorPipe,
    TimeFromNowPipe,
    InfiniteScrollDirective,
    SkeletonModule,
    ButtonModule,
    InputTextModule,
    RadioButtonModule,
    Drawer,
    ProgressBarModule,
    ToastModule,
    RippleModule,
    AvatarModule,
    FilelinkModule,
    OverlayModule,
    BadgeModule,
    GetIconCssClassPipe,
    CssStylerDirective,
    GetEntryFieldWrapperClassPipe,
    CssStylerDirective,
    GetViewConfigCssRulesPipe,
    SafePipe,
    SelectModule,
    OsosSelectModule,
    RouterLink,
    RouterLinkActive,
    Tooltip,
    RouterOutlet,
    //standalone
    FormFieldComponent,
    FormFieldLabelDirective,
    PrimeTextFormFieldControlDirective,
    PrimeWrapperFormFieldControlDirective,
    BreadcrumbComponent,
    PopoverModule,
    CloseMenuOnScrollDirective,
    DelegationBadgeComponent,
    ValueBasedTooltipComponent,
    HelpAndDocumentationButtonComponent,
    TieredSplitButtonComponent,
    HelpButtonPositionerDirective,
    UserDelegationsComponent,
    ExitDelegationButtonComponent,
  ],
  exports: [MainComponent],
  providers: [
    MenuService,
    NavService,
    MenuAsideService,
    PortalMenuService,
    MenuConfigService,
    SplitButtonStyle,
  ],
})
export class LayoutModule {
  constructor(@Optional() @SkipSelf() parentModule: LayoutModule) {
    if (parentModule) {
      throw new Error(
        'LayoutModule is already loaded. Import in your base AppModule only.',
      );
    }
  }
}
